import type { ComponentPropsWithoutRef } from "react";
import { CFormTextarea } from "@coreui/react";

interface BaseTextareaProps extends ComponentPropsWithoutRef<typeof CFormTextarea> {}

export interface CJsonTextAreaProps extends BaseTextareaProps {
  style?: BaseTextareaProps["style"];
  rows?: number;
  placeholder?: string;
}

export const CJsonTextArea = ({
  style,
  rows = 12,
  placeholder = "Enter JSON...",
  ...rest
}: CJsonTextAreaProps) => (
  <CFormTextarea
    rows={rows}
    {...rest}
    style={{
      fontFamily: "monospace",
      fontSize: "14px",
      resize: "vertical",
      ...(style || {}),
    }}
    placeholder={placeholder}
  />
);
